<div class="dls-splash-screen pt-login">
    <dls-layout-container class="pt-layout-container" data-automation-id="app-splash-container">
        <dls-icon class="icon-dls-about pt-logo pt-icon"></dls-icon>
        <dls-label class="pt-application-name pt-label">{{ 'BREASE PLATFORM PROTOTYPE UI' }}</dls-label>
        <dls-progress-circular-indeterminate class="pt-circular-medium"></dls-progress-circular-indeterminate>
        <div class="pt-login-footer">
            <div class="pt-footer-icons">
                <dls-icon class="icon-dls-brand-readmanual pt-readmanual-icon pt-icon"></dls-icon>
                <dls-icon class="icon-dls-brand-warning pt-warning-icon pt-icon"></dls-icon>
            </div>
        </div>
    </dls-layout-container>
</div>
